import React, { createContext, useContext, useState } from 'react'
import { ContactSlugEnum } from 'src/shared/enums/contact-fields-enum'

type FieldsValuesType = Partial<Record<ContactSlugEnum, string | undefined>>
type CheckboxesValuesType = Record<string, boolean>
type FieldsErrorsType = Partial<Record<ContactSlugEnum, string[]>>
type CommonErrorsType = string[]

interface FormContextInterface {
  fieldsValues: FieldsValuesType
  setFieldsValues: (fields: FieldsValuesType) => void
  checkboxesValues: CheckboxesValuesType
  setCheckboxesValues: (checkboxes: CheckboxesValuesType) => void
  fieldsErrors: FieldsErrorsType
  setFieldsErrors: (fieldsErrors: FieldsErrorsType) => void
  commonErrors: string[]
  setCommonErrors: (commonErrors: string[]) => void
}

const FormContext = createContext<FormContextInterface>({
  fieldsValues: {},
  setFieldsValues: () => ({}),
  checkboxesValues: {},
  setCheckboxesValues: () => ({}),
  fieldsErrors: {},
  setFieldsErrors: () => ({}),
  commonErrors: [],
  setCommonErrors: () => [],
})

export const useFormContext = () => useContext(FormContext)

export const FormProvider = (props: React.PropsWithChildren) => {
  const [fieldsValues, setFieldsValues] = useState<FieldsValuesType>({})
  const [checkboxesValues, setCheckboxesValues] =
    useState<CheckboxesValuesType>({})
  const [fieldsErrors, setFieldsErrors] = useState<FieldsErrorsType>({})
  const [commonErrors, setCommonErrors] = useState<CommonErrorsType>([])

  return (
    <FormContext.Provider
      value={{
        fieldsValues,
        setFieldsValues,
        checkboxesValues,
        setCheckboxesValues,
        fieldsErrors,
        setFieldsErrors,
        commonErrors,
        setCommonErrors,
      }}
    >
      {props.children}
    </FormContext.Provider>
  )
}
